module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-music-44dc1cb5.svg";